<p-tabView [(activeIndex)]="selectedTabIndex">
    <p-tabPanel header="CRM">
        <p-table [value]="series" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Module Name</th>
                    <th>Starting No.</th>
                    <th>Ending No.</th>
                    <th>Last Date Used</th>
                    <th>Last No. Used</th>
                    <th>Auto No.</th>
                    <!-- <th>Manual No.</th> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr>
                    <td>{{product.moduleName}}</td>
                    <td>
                        <span class="pointer" (click)="editNumber(product)">
                            {{product.prefix}}{{product.startingSequenceNumber}}
                        </span>

                    </td>
                    <td>
                        <span class="pointer" (click)="editNumber(product)">
                            {{product.prefix}}{{product.endingSequenceNumber}}
                        </span>
                    </td>
                    <td>{{product.lastUsedDate | date:'MM/dd/yyyy'}}</td>
                    <td>{{ product.lastUsedSequenceNumber ? product.prefix :'' }}{{product.lastUsedSequenceNumber }}
                    </td>

                    <td class="action">
                        <p-checkbox [(ngModel)]="product.enableAutoGeneration" [binary]="true" inputId="binary"
                            (click)="onCheckboxChange(product,'auto')" disabled></p-checkbox>
                    </td>
                    <!-- <td class="action">
                        <p-checkbox [(ngModel)]="product.enableManualEntry" (click)="onCheckboxChange(product,'manual')"  [binary]="true" inputId="binary"></p-checkbox >
                    </td> -->
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <!-- <p-tabPanel header="FSM">
        Content 2
    </p-tabPanel>
    <p-tabPanel header="Inventory">
        Content 3
    </p-tabPanel> -->
</p-tabView>
<p-dialog header="Edit {{selectedModuleHeader}} Series  No." [(visible)]="displayEditNumber" [modal]="true"
    [responsive]="true" [style]="{width: '60em'}">
    <form class="card" [formGroup]="numberSeriesForm">
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <label>Prefix</label>
                <input type="text"  (input)="numberSeriesForm.get('prefix').setValue($event.target.value.toUpperCase())" (keypress)="characterOnly($event)" formControlName="prefix" tooltipPosition="top"
                    pInputText>
                <small class="p-invalid p-mt-2"
                    *ngIf="numberSeriesForm.get('prefix').invalid && (numberSeriesForm.get('prefix').dirty || numberSeriesForm.get('prefix').touched)">
                    <!-- <small class="p-invalid p-mt-2" *ngIf="numberSeriesForm.get('prefix').errors.required">Prefix  is required</small> -->
                    <small class="p-invalid p-mt-2" *ngIf="numberSeriesForm.get('prefix').errors.maxlength ||numberSeriesForm.get('prefix').errors">Prefix
                        required with atmost 3 Characters</small>
                </small>
            </div>
            <div class="p-col-8 p-md-4">
                <label>Starting No.</label>
                <input [ngClass]="{'custom_invalid' : numberSeriesForm['errors']?.numberRangeInvalid}"
                    (keypress)="numberOnly($event)" formControlName="startingSequenceNumber" required
                    (keyup)="calulateNumber()" pInputText>
                <small class="f-small p-invalid p-mt-2" *ngIf="numberSeriesForm['errors']?.numberRangeInvalid">Starting
                    No. cannot be greater than Ending No.</small>

                <small class="p-mt-2"
                    *ngIf="numberSeriesForm.get('startingSequenceNumber').invalid && (numberSeriesForm.get('startingSequenceNumber').dirty || numberSeriesForm.get('startingSequenceNumber').touched)">
                    <small class="p-invalid p-mt-2"
                        *ngIf="numberSeriesForm.get('startingSequenceNumber').errors.required">Starting No. is
                        required</small>
                </small>
            </div>
            <div class="p-col-8 p-md-4">
                <label>Ending No.</label>
                <input required (keypress)="numberOnly($event)" formControlName="endingSequenceNumber"
                    (keyup)="calulateNumber()" pInputText>
                <small class="p-invalid p-mt-2"
                    *ngIf="numberSeriesForm.get('endingSequenceNumber').invalid && (numberSeriesForm.get('endingSequenceNumber').dirty || numberSeriesForm.get('endingSequenceNumber').touched)">
                    <small class="p-invalid p-mt-2"
                        *ngIf="numberSeriesForm.get('endingSequenceNumber').errors.required">Ending No. is
                        required</small>
                    <!-- <small class="p-invalid p-mt-2" *ngIf="numberSeriesForm.get('endingSequenceNumber').errors.startGreaterThanEnd">Starting No. cannot be greater than Ending No.</small> -->
                </small>
            </div>
            <div class="p-col-4 p-md-2">
                <label>Max No.</label>
                <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="returnNumber" required #maxNoInput="ngModel"
                    disabled></p-inputNumber>
                    <small class=" f-small p-invalid p-mt-2"  *ngIf="returnNumber < 10000">Max No. should be atleast 10,000</small>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayEditNumber=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton (click)="save()" [disabled]="!numberSeriesForm.valid  || returnNumber <10000" label="Save"></button>
    </p-footer>
</p-dialog>
